import { createUseStyles } from 'react-jss';
const useActionButtonStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        padding: '0.2rem 0.7rem',
        borderRadius: '5.7rem',
        height: '1.42rem',
        backgroundColor: theme.colors.grey[4],
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        fontSize: theme.typography.fontSize[1],
        lineHeight: `${theme.typography.lineHeights[0]} px`
    }
}));
export default useActionButtonStyles;
